import { CmpInvoiceKindEnum } from "../../../../graphql/types";
import { isEventInvoiceKind } from "./manageInvoiceActions";
import { getManageEventInvoiceIdentity } from "./manageEventInvoiceIdentity";

type EventSourceInvoice = Readonly<{
  eventId?: string | null;
  eventRegistrationId?: string | null;
  eventSponsorshipRequestId?: string | null;
  id: string;
}>;

/**
 * An event invoice uses the Event Sales payment, void and credit actions only
 * when it names its event and its registration or sponsorship. An imported
 * event invoice without those links uses the generic invoice actions, which
 * the backend allows only for that case. Until the invoice detail loads, the
 * event path is kept so no generic action starts on a linked sale.
 */
export const usesManageEventInvoiceSourceActions = ({
  chamberId,
  detailInvoice,
  row,
}: {
  chamberId: string;
  detailInvoice?: EventSourceInvoice | null;
  row: Readonly<{ id: string; invoiceKind: CmpInvoiceKindEnum }>;
}): boolean => {
  if (!isEventInvoiceKind(row.invoiceKind)) {
    return false;
  }
  if (!detailInvoice || detailInvoice.id !== row.id) {
    return true;
  }
  return (
    getManageEventInvoiceIdentity({
      chamberId,
      eventId: detailInvoice.eventId,
      eventRegistrationId: detailInvoice.eventRegistrationId,
      eventSponsorshipRequestId: detailInvoice.eventSponsorshipRequestId,
      invoiceId: detailInvoice.id,
      invoiceKind: row.invoiceKind,
    }) !== null
  );
};
